import IFACE, { EL } from './IFACE.js';
import Deselect from '../event/Deselect.js';
import Select from '../event/Select.js';
/** An interface for Select driven Events */
export default class Selectable extends IFACE {
    /** A series of Select Related Events and Methods
        @param {EL} node Class to implement this interface (Typically 'this')
    */
    constructor(node) {
        super(node, 'selectable');
    }
    addListeners(node) {
        node.on('select', () => node.select());
        node.on('selectAll', () => node.selectAll());
        node.on('deselect', () => node.deselect());
        node.on('deselectAll', () => node.deselectAll());
    }
    setMethods(node) {
        /** Select this element */
        this.methods.select = () => node.chain(() => {
            try {
                //this.methods.deselectAll().then(() => node.addClass('selected'));
                node.deselectAll().then(() => node.addClass('selected'));
            }
            catch (e) {
                if (e instanceof TypeError) {
                    console.warn('Unable to deselect node (Consider stopping propagation)', node, e);
                }
            }
        });
        /** Selects any 'selectable' elements */
        this.methods.selectAll = () => node.chain(() => node.get().forEach((el) => {
            if (el.hasClass('selectable')) {
                el.addClass('selected');
                //el.do(new Select(node));
            }
        }));
        //Promise.resolve(Array.from(document.getElementsByClassName('selectable')).forEach((el) => el.classList.add('selected')));
        /** Deselect this element */
        this.methods.deselect = () => node.removeClass('selected');
        /** Deselects any 'selected' elements */
        this.methods.deselectAll = () => node.chain(() => node.get().forEach((el) => {
            if (el.hasClass('selectable')) {
                el.removeClass('selected');
                //el.do(new Deselect(node));
            }
        }));
        //Array.from(document.getElementsByClassName('selected')).forEach((el) => el.dispatchEvent(new Deselect(node)));
    }
}
export { Deselect, EL, Select };
